module.exports = __webpack_public_path__ + "static/media/DSC02189.c58b5f6b.jpg";